import { render, staticRenderFns } from "./autocomplete-suggestions.vue?vue&type=template&id=881bb22c&scoped=true&"
import script from "./autocomplete-suggestions.vue?vue&type=script&lang=js&"
export * from "./autocomplete-suggestions.vue?vue&type=script&lang=js&"
import style0 from "./autocomplete-suggestions.vue?vue&type=style&index=0&id=881bb22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881bb22c",
  null
  
)

export default component.exports